import api from './api';

const API_URL = '/holidays';

export interface Holiday {
  _id: string;
  name: string;
  date: string;
  type: 'NATIONAL' | 'RELIGIOUS' | 'ACADEMIC' | 'OTHER';
  isRecurring: boolean;
  parentHolidayId?: string | null;
  schoolId: string;
  isActive: boolean;
}

export interface CreateHolidayData {
  name: string;
  date: string;
  type: string;
  isRecurring: boolean;
}

const getHolidays = async (year?: number): Promise<Holiday[]> => {
  const params: any = {};
  if (year) params.year = year;
  
  const response = await api.get(API_URL, {
    params
  });
  return response.data.data;
};

const createHoliday = async (data: CreateHolidayData): Promise<Holiday> => {
  const response = await api.post(API_URL, data);
  return response.data.data;
};

const updateHoliday = async (id: string, data: Partial<CreateHolidayData>): Promise<Holiday> => {
  const response = await api.put(`${API_URL}/${id}`, data);
  return response.data.data;
};

const deleteHoliday = async (id: string): Promise<void> => {
  await api.delete(`${API_URL}/${id}`);
};

const holidayService = {
  getHolidays,
  createHoliday,
  updateHoliday,
  deleteHoliday
};

export default holidayService;
